// frontend/src/StoreLocator/Tags.jsx
import React, { useState } from 'react';
import { Alert, useList } from '../GiftCards/common';
import { slApi } from './apiClient';

export default function Tags({ ctx }) {
  const { data, error, reload } = useList(() => slApi.tags(), []);
  const [form, setForm] = useState(null);
  const [err, setErr] = useState('');
  const save = async () => {
    setErr('');
    try { if (form.id) await slApi.updateTag(form.id, form); else await slApi.addTag(form); setForm(null); reload(); ctx.reloadMeta(); } catch (e) { setErr(e.message); }
  };
  const remove = async (t) => { if (!window.confirm(`Remove the tag ${t.title} from ${t.locations} location${t.locations === 1 ? '' : 's'}?`)) return; try { await slApi.removeTag(t.id); reload(); ctx.reloadMeta(); } catch (e) { ctx.notify(e.message); } };
  const tags = (data && data.tags) || [];
  return (
    <div className="uh-card">
      <div className="uh-ia-tbar"><span className="uh-ia-hint">Tags group stores (Corporate, Franchise, a metro) and target special hours and notifications. A tag shown as a map filter appears as a checkbox on the map page.</span><span className="uh-sp" /><button type="button" className="uh-btn primary" onClick={() => setForm({ title: '', group: '', description: '', show_on_filter: false })}>Add tag</button></div>
      <div className="uh-card-b">
        <Alert>{error}</Alert>
        {form && (
          <div className="uh-form-card uh-sl-form">
            <div className="uh-ia-frow">
              <label className="uh-ia-fld"><span className="lab">Tag</span><input className="uh-ia-inp" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></label>
              <label className="uh-ia-fld"><span className="lab">Group</span><input className="uh-ia-inp" value={form.group || ''} placeholder="Metro" onChange={(e) => setForm({ ...form, group: e.target.value })} /></label>
              <label className="uh-ia-fld uh-span2"><span className="lab">Description</span><input className="uh-ia-inp" value={form.description || ''} onChange={(e) => setForm({ ...form, description: e.target.value })} /></label>
              <label className="uh-ia-check"><input type="checkbox" checked={!!form.show_on_filter} onChange={(e) => setForm({ ...form, show_on_filter: e.target.checked })} /> Shown as a map filter</label>
            </div>
            {err && <div className="uh-ia-bad">{err}</div>}
            <div className="uh-ia-row"><button type="button" className="uh-btn primary" onClick={save}>{form.id ? 'Save' : 'Add'}</button><button type="button" className="uh-btn" onClick={() => setForm(null)}>Cancel</button></div>
          </div>
        )}
        <div className="uh-tscroll"><table className="uh-tbl">
          <thead><tr><th>Tag</th><th>Group</th><th>Description</th><th>Map filter</th><th>Locations</th><th /></tr></thead>
          <tbody>
            {tags.map((t) => <tr key={t.id}><td><b>{t.title}</b></td><td>{t.group}</td><td>{t.description}</td><td>{t.show_on_filter ? 'Yes' : 'No'}</td><td className="uh-num">{t.locations}</td><td className="uh-ia-nowrap"><button type="button" className="uh-btn slim" onClick={() => setForm(t)}>Edit</button> <button type="button" className="uh-btn slim" onClick={() => remove(t)}>Remove</button></td></tr>)}
            {data && tags.length === 0 && <tr><td colSpan={6} className="uh-empty">No tags yet.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
